import React, { useState } from 'react';
import {
  Box, Button, Typography, Card, CardContent, CardMedia, TextField,
  IconButton, Menu, MenuItem
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Tooltip from '@mui/material/Tooltip';
import TempNameEllipsisText from './TempNameEllipsisText';
const RecruiterCard = ({
  name,
  logo,
  onRemove,
  onEditName,
  removeLabel = "Remove"
}) => {
  const [editing, setEditing] = useState(false);
  const [tempName, setTempName] = useState(name);
  const [anchorEl, setAnchorEl] = useState(null);

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => setAnchorEl(null);

  const handleEditClick = () => {
    setEditing(true);
    closeMenu();
  };

  const handleSaveName = () => {
    if (onEditName) onEditName(tempName);
    setEditing(false);
  };

  const handleCancel = () => {
    setTempName(name); // reset to original
    setEditing(false);
  };

  return (
    <Card sx={{ textAlign: 'center', p: 2, position: 'relative', boxShadow:'0px 0px 32px 0px rgba(9, 26, 68, 0.07)', }}>
      {/* 3-dot menu */}
      {!editing && (
        <IconButton
          size="small"
          onClick={openMenu}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      )}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem onClick={handleEditClick} sx={{fontSize:'13px'}}>Edit</MenuItem>
      </Menu>

      {/* Logo */}
     <Box
  sx={{
    height: 100,
    width: 100,
    mx: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 1,
    overflow: 'hidden',
  }}
>
  <Box
    component="img"
    src={logo}
    alt={name}
    sx={{
      maxHeight: '100%',
      maxWidth: '100%',
      objectFit: 'contain',
    }}
  />
</Box>

      <CardContent>
        {editing ? (
          <>
            <TextField
              size="small"
              value={tempName}
              onChange={(e) => setTempName(e.target.value)}
              fullWidth
              sx={{ mb: 1 }}
            />
            <Box display="flex" gap={1} justifyContent="center">
              <Button size="small" variant="contained" onClick={handleSaveName}>
                Save
              </Button>
              <Button size="small" variant="outlined" onClick={handleCancel}>
                Cancel
              </Button>
            </Box>
          </>
        ) : (
          <>
            <TempNameEllipsisText text={tempName} />


            {onRemove && (
              <Button
  size="small"
  onClick={onRemove}
  variant="outlined"
  sx={{
    color: removeLabel === 'Add' ? 'primary.main' : 'error.main',
    borderColor: removeLabel === 'Add' ? 'primary.main' : 'error.main',
    '&:hover': {
      backgroundColor: removeLabel === 'Add' ? 'primary.main' : 'error.main',
      color: '#fff',
      borderColor: removeLabel === 'Add' ? 'primary.main' : 'error.main',
    },
  }}
>
  {removeLabel}
</Button>

            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default RecruiterCard;
